export default __webpack_public_path__ + "static/media/allow-safra-5.e1b2edc9.png";